/**
 * @flow
 * @relayHash 37e4d2d2fcadf0a16c07ea7e73ef8203
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQueryVariables = {|
  itemId?: ?string
|};
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQueryResponse = {|
  +viewer: ?{|
    +item: ?{|
      +status: ?string,
      +pricing: ?{|
        +bargain: ?any
      |},
    |}
  |}
|};
export type pdpSharedNotificationMultiplePdpVisitsModalConfigQuery = {|
  variables: pdpSharedNotificationMultiplePdpVisitsModalConfigQueryVariables,
  response: pdpSharedNotificationMultiplePdpVisitsModalConfigQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String",
    "defaultValue": ""
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pricing",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemPricing",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "bargain",
      "args": null,
      "storageKey": null
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "id": "app-buyer-finding/209.0.0-2019-03-27T14:13:29.601Z/pdpSharedNotificationMultiplePdpVisitsModalConfigQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '48558b5fd9fbbbd80322ce6e5c3f77fb';
module.exports = node;
